import { faChrome, faGithub } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Grid, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
import { COLORS } from '../../../constants/colors';
import { CANDIDATE } from '../../../constants/props';
import Section from '../../common/section';
import Interview from '../../interview';

const useStyles = makeStyles({
  main: {
    height: '23.1875rem',
    padding: '1.25rem',
    '& h1, & h2': {
      textTransform: 'uppercase',
      marginBottom: '0.3125rem',
    },
  },
  title: {
    fontSize: '3.125rem',
    fontWeight: 'bold',
    lineHeight: '3.6875rem',
    ['@media (max-width:566px)']: {
      fontSize: '2.125rem',
      lineHeight: '2.6875rem',
    },
  },
  subtitle: {
    fontSize: '1.5rem',
  },
  description: {
    fontSize: '1rem',
    lineHeight: '1.1875rem',
    marginBottom: '0.3125rem',
  },
  github: {
    color: COLORS.grayScale[5],
    ['@media (max-width:1034px)']: {
      margin: '10px 0 0 0',
    },
    ['@media (max-width:960px)']: {
      margin: '0 0 0 10px',
    },
    ['@media (max-width:566px)']: {
      margin: '10px 0 0 0',
    },
  },
  video: {
    height: '23.1875rem',
    width: '100%',
    border: 'none',
    borderRadius: '0.3125rem',
  },
});

const View = ({
  firstName,
  role,
  city,
  country,
  availability,
  github,
  online,
  video,
}) => {
  const classes = useStyles();
  const [candidateVideo, setCandidateVideo] = useState('');
  useEffect(() => {
    if(video && video.includes('watch?v=')) {
      const videoUrl = video.replace('watch?v=', 'embed/');
      setCandidateVideo(videoUrl);
    } else {
      setCandidateVideo(video);
    }
  }, [video]);

  return (
    <Section>
      <Grid container spacing={2}>
        <Grid item xs={12} md>
          <Paper>
            <Grid
              className={classes.main}
              container
              direction="column"
              justify="space-between"
            >
              <Grid item>
                <Typography className={classes.title} variant="h1">
                  {firstName}
                </Typography>
                <Typography
                  className={classes.subtitle}
                  variant="h2"
                  color="textSecondary"
                >
                  {role.name}
                </Typography>
                <Typography
                  className={classes.description}
                  variant="subtitle1"
                >{`${city}, ${country}`}</Typography>
                <Typography className={classes.description} variant="subtitle1">
                  {availability.description}
                </Typography>
              </Grid>
              <Grid item container justify="space-between">
                <Grid item>
                  <Interview />
                </Grid>
                <Grid item>
                  {(github || online) && (
                    <Button
                      href={github || online}
                      className={classes.github}
                      target="blank"
                      variant="outlined"
                      color="primary"
                      startIcon={
                        <FontAwesomeIcon icon={github ? faGithub : faChrome} />
                      }
                    >
                      {github ? 'Github' : 'Portfolio'}
                    </Button>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid item xs={12} md>
          {candidateVideo && (
            <iframe
              className={classes.video}
              src={candidateVideo}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title="Candidate presentation"
              loading="lazy"
            ></iframe>
          )}
        </Grid>
      </Grid>
    </Section>
  );
};

View.propTypes = {
  CANDIDATE,
};

export default View;
